// extracted by extract-css-chunks-webpack-plugin
module.exports = {"placeHolder":"B-5N3","certonaDealsProdCatridge":"_5oHBS","certonaDealsWrapper":"O7-T2"};